import { render, staticRenderFns } from "./Gallery16.vue?vue&type=template&id=a85f7bb6&scoped=true&"
import script from "./Gallery16.vue?vue&type=script&lang=js&"
export * from "./Gallery16.vue?vue&type=script&lang=js&"
import style0 from "./Gallery16.vue?vue&type=style&index=0&id=a85f7bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85f7bb6",
  null
  
)

export default component.exports